import { IonContent } from '@ionic/react';
import React from 'react';

import { S3_BUCKET_URL } from '@/constants.ts';
import { useAccount } from '@/hooks/useAccount';
import { amplitudeModule } from '@/modules/amplitude';
import { getBotSlug } from '@/modules/botSlug.ts';
import { chatPinner } from '@/modules/chatPinner';
import { OnboardingFooter } from '@/pages/Onboarding/components/Footer';
import { OnboardingSubtitle } from '@/pages/Onboarding/components/Subtitle';
import { useOnboarding } from '@/pages/Onboarding/context';
import { useManLayoutSelections } from '@/pages/Onboarding/hooks/useManLayoutSelections.ts';
import { OwnAiTitle } from '@/pages/Onboarding/Layouts/OwnAI/components/Title';
import { userService } from '@/services/user';
import { canLogEvents } from '@/utils/canLogEvents';

import { HARDCODED_CATEGORIES } from '../../../constants';

import { ScreenAboutLookStyles } from './AboutLookMale.styles';

export const ScreenAboutLook: React.FC = () => {
  const { user } = useAccount();

  React.useEffect(() => {
    if (canLogEvents()) {
      amplitudeModule.logEvent('onboarding_screen', {
        seen: 'AboutLook',
      });
    }
  }, []);

  const { ageGeneration, bodyShape, ethnicity } = useManLayoutSelections();

  const { wizard } = useOnboarding();
  const { refreshUser } = useAccount();

  const handleNextStep = (): void => {
    userService.createOrUpdate({
      categories: HARDCODED_CATEGORIES,
      onboarding_data: {
        first_categories: HARDCODED_CATEGORIES,
      },
    });
    refreshUser();
    wizard.nextStep();

    const slug = getBotSlug({
      ageGeneration,
      bodyShape,
      ethnicity,
      gender: 'male',
    });
    if (user && slug) {
      chatPinner.pin(slug, user.id);
    }
  };

  return (
    <ScreenAboutLookStyles
      bgImage={
        <img
          src={`${S3_BUCKET_URL}/layout-own-ai-man/bg-about-look.png`}
          alt="Chat Vibe"
        />
      }
    >
      <IonContent>
        <OwnAiTitle className="local-title">Wow, your taste is 🔥</OwnAiTitle>
        <OnboardingSubtitle>
          Let’s add a few final touches to make it
          <br />a night to remember.
        </OnboardingSubtitle>
      </IonContent>

      <OnboardingFooter onContinue={handleNextStep} />
    </ScreenAboutLookStyles>
  );
};
